import { useRef } from "react";
import { Input, Space, Button } from "antd";
import type { InputRef } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ClassificationDropdown } from "../../ClassificationDropdown";
import { useChatStore } from "@stores/chatStore";
import { CHANNELS } from "@common";
import styles from "./styles.module.less";

interface ConversationSearchProps {
  searchValue: string;
  onSearch: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedTagIds: string[];
  onTagsChange: (tagIds: string[]) => void;
}

export const ConversationSearch = ({
  searchValue,
  onSearch,
  onChange,
  selectedTagIds,
  onTagsChange,
}: ConversationSearchProps) => {
  const inputRef = useRef<InputRef>(null);
  const selectedChannel = useChatStore((state) => state.selectedChannel);

  const handlePressEnter = () => {
    onSearch();
  };

  return (
    <div className={styles.search}>
      <div className={styles.searchInputWrapper}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            ref={inputRef}
            placeholder="Tìm kiếm hội thoại..."
            allowClear
            value={searchValue}
            onPressEnter={handlePressEnter}
            onChange={onChange}
            className={styles.searchInput}
          />
          <Button
            icon={<SearchOutlined />}
            onClick={onSearch}
            className={styles.searchButton}
          />
        </Space.Compact>
      </div>
      {selectedChannel !== CHANNELS.ZALO && (
        <div className={styles.classificationWrapper}>
          <ClassificationDropdown
            selectedTagIds={selectedTagIds}
            onTagsChange={onTagsChange}
          />
        </div>
      )}
    </div>
  );
};
